import { Component, OnInit, inject ,Inject} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { AWSLambda } from 'src/app/AWSLambda.service';
import { BoRolesCheckService } from 'src/app/components/rolesCheck/bo-roles-check.service';
import {Auth} from "aws-amplify";
import {AuthService} from "../../../services/auth.service";
import {AuthenticatorService} from "@aws-amplify/ui-angular";

@Component({
  selector: 'app-edit-call-price',
  templateUrl: './edit-call-price.component.html',
})
export class BOEditCallPriceComponent implements OnInit {

  _snackBar = inject(MatSnackBar);
  router = inject(Router);
  rolesCheck = inject(BoRolesCheckService);
  auth = inject(AuthService);
  user = inject(AuthenticatorService).user;

  canAccess = false;

  priceData: any;

  constructor(private lambda: AWSLambda) {}

  createForm: FormGroup = new FormGroup({
    network: new FormControl({ value: '', disabled: true }),
    amount: new FormControl('', Validators.required),
    countryCode: new FormControl({ value: '', disabled: true }),
    vendor: new FormControl({ value: '', disabled: true }),
    default: new FormControl({ value: false, disabled: true }),
    regexFilter: new FormControl({ value: '', disabled: true }),
    createdAt: new FormControl({ value: '', disabled: true }),
    updatedAt: new FormControl({ value: '', disabled: true }),
  });

  async ngOnInit() {
    this.canAccess = await this.rolesCheck.checkAccess();
    if (!this.canAccess) {
      return;
    }

    try {
      await this.auth.refresh();
      this.user = await Auth.currentAuthenticatedUser();
      console.log('> user:', this.user?.attributes?.['sub']);

      // todo: recibir ID y cargar aquí la tarifa para evitar problemas de datos cacheados

      sessionStorage.setItem('back_url', '/backoffice/calls-pricing');
      const priceDataId = sessionStorage.getItem('boCallPriceEdit');

      this.priceData = await this.lambda.getLambdaFunction('lambda', '/pricing/calls', {
        queryStringParameters: {
          method: 'byId',
          priceId: priceDataId,
        }
      });
      console.log('> priceData:', this.priceData);

      if (!this.priceData || !this.priceData.id) {
        this._snackBar.open('No se ha encontrado la tarifa', 'Close', {
          duration: 5000,
        });
        this.router.navigate(['/backoffice/calls-pricing']);
        return;
      }

      this.createForm.patchValue({
        network: this.priceData.network,
        amount: this.priceData.amountPerMinuteEuro.toString(),
        countryCode: this.priceData.toCountryCode,
        vendor: this.priceData.vendor,
        default: this.priceData.default,
        regexFilter: this.priceData.regexFilter,
        createdAt: this.priceData.createdAt,
        updatedAt: this.priceData.updatedAt,
      });
    } catch (error) {
      console.log('Backoffice - Error getting call price:', error);
    }
  }

  async onUpdate() {
    const form = this.createForm;
    const formValue = form.getRawValue();
    console.log(formValue);

    const trimmedAmount = formValue['amount']?.trim();
    if (!trimmedAmount || trimmedAmount.includes(',')) {
      this._snackBar.open('Please check the required inputs', 'Close', {
        duration: 5000,
      });
      return;
    }
    else
    {
      this.lambda.getLambdaFunction(
        "lambda",
        "/pricing/calls",
        {
          queryStringParameters: {
            "method": "update",
            "sub": this.user?.attributes?.['sub'] ?? '',
            "priceId": this.priceData.id,
            "newAmount": trimmedAmount,
          }
        }
      ).then((result: any) => {
        console.log('>> result:', result);
        if(result.ok){
          this._snackBar.open(
            'Tarifa actualizada satisfactoriamente.',
            'Close',
            {
              duration: 5000,
            }
          );

          this.router.navigate(['/backoffice/calls-pricing/edit'], { replaceUrl: true });
        }
        else
        {
          this._snackBar.open('Failed:'+result.message, 'Close', {
            duration: 5000,
          });
        }
      }).catch((error: any) => {
        this._snackBar.open(
          'Error al actualizar la tarifa. Por favor, inténtelo de nuevo.',
          'Close',
          {
            duration: 5000,
          }
        );
        console.error('Error updating call price:', error);
        return;
      })
    }
  }

  goBack() {
    this.router.navigate(['/backoffice/calls-pricing'], { replaceUrl: true });
  }

  protected readonly Object = Object;
}
